module.exports = __webpack_public_path__ + "img/Technische tekeningen.868cf63c.svg";